import ContentSection from "../ContentSection";
import ScrollContainer from "react-indiana-drag-scroll";

//Only imported when there's necessary daya for it
function PatternAndCluster({ KeyPatternsAndClusters, col = false, colSpan }) {
  return (
    <div
      className={`h-auto w-full rounded-lg bg-white p-6 text-left ${
        col ? `col-span-${colSpan}` : ""
      }`}
    >
      <h1 className="text-left text-2xl font-bold text-black">
        Key Sub-patterns
      </h1>
      <ScrollContainer
        vertical={true}
        className="grid h-[500px] grid-cols-1 items-start gap-6 overflow-y-scroll rounded-lg px-4 py-16 shadow-socialglass [-ms-overflow-style:none] [scrollbar-width:none] active:cursor-grabbing [&::-webkit-scrollbar]:hidden"
      >
        {KeyPatternsAndClusters.map((cluster) => (
          <ContentSection
            key={cluster.title}
            category={cluster.title}
            subtitle={cluster.subHeading}
            pills={cluster.subList}
          />
        ))}
      </ScrollContainer>
    </div>
  );
}

export default PatternAndCluster;
